module.exports = __webpack_public_path__ + "static/media/auth-succes.88bbc372.svg";